/** Props for {@link Spinner}. */
export interface SpinnerProps {
  /** Accessible label announced while busy. */
  readonly label?: string;
}

/**
 * An indeterminate loading indicator.
 *
 * @param props - Component props.
 * @returns The spinner element.
 */
export function Spinner({ label = 'Loading' }: SpinnerProps): React.JSX.Element {
  return <div className="gm-spinner" role="status" aria-label={label} />;
}
